import { MouseEvent, RefObject, createContext } from "react";
import type { OpenCloseTransitionStates } from "../../../internal/hooks/useOpenCloseTransitionStates/useOpenCloseTransitionStates";

/**
 * Context props for the Drawer component
 */
export type DrawerContextProps = {
  /**
   * Function to close the drawer.
   */
  close: (e?: MouseEvent<HTMLElement>) => void;
  /**
   * Reference to the drawer dialog element.
   */
  ref?: RefObject<HTMLDialogElement>;
  /**
   * Reference to the drawer header element for sticky content positioning.
   */
  headerRef?: RefObject<HTMLElement>;
  /**
   * The current transition state of the drawer.
   */
  state?: OpenCloseTransitionStates;
};

export const DrawerContext = createContext<DrawerContextProps | null>(null);
